import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { adminFetch, setAdminSessionToken } from "../../services/adminClient";

const AdminLogin = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { loginSucceeded, admin, checking } = useAdminAuth();

  useEffect(() => {
    if (!checking && admin) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [admin, checking, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!String(form.username || "").trim()) {
      setError("Please enter your admin username.");
      return;
    }
    try {
      const res = await adminFetch("/login", {
        method: "POST",
        body: {
          email: form.username,
          password: form.password,
        },
      });

      let data = {};
      try {
        data = await res.json();
      } catch {
        data = {};
      }

      if (res.ok && data.ok === true && data.role === "admin") {
        // Persist the JWT as a Bearer fallback for environments where the
        // HttpOnly cookie is blocked (cross-origin/SameSite issues).
        if (data.token) setAdminSessionToken(data.token);
        loginSucceeded();
        navigate("/admin/dashboard", { replace: true });
        return;
      }

      setError(data.error || "Login failed.");
    } catch {
      setError("Something went wrong. Try again.");
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-slate-900 via-slate-900 to-slate-800 px-4 py-10">
      <div className="mb-8 text-center text-slate-400">
        <p className="text-xs font-semibold uppercase tracking-[0.25em]">Restricted</p>
        <h1 className="mt-1 text-2xl font-bold tracking-tight text-white">Admin sign-in</h1>
      </div>
      <div className="w-full max-w-md rounded-2xl border border-slate-700/60 bg-slate-800/40 p-6 shadow-2xl shadow-black/40 backdrop-blur sm:p-8">
        <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
          <input
            type="text"
            name="username"
            id="mmd-admin-username"
            value={form.username}
            onChange={handleChange}
            required
            autoComplete="off"
            data-lpignore="true"
            data-1p-ignore
            spellCheck={false}
            placeholder="Username"
            className="w-full rounded-xl border border-slate-600 bg-slate-900/60 px-4 py-3 text-white placeholder:text-slate-500 focus:border-rose-500 focus:outline-none focus:ring-2 focus:ring-rose-500/30"
          />
          <input
            type="password"
            name="password"
            id="mmd-admin-password"
            value={form.password}
            onChange={handleChange}
            required
            autoComplete="off"
            data-lpignore="true"
            data-1p-ignore
            placeholder="Password"
            className="w-full rounded-xl border border-slate-600 bg-slate-900/60 px-4 py-3 text-white placeholder:text-slate-500 focus:border-rose-500 focus:outline-none focus:ring-2 focus:ring-rose-500/30"
          />
          <button
            type="submit"
            className="w-full rounded-xl bg-rose-600 py-3 text-sm font-semibold text-white shadow-lg shadow-rose-900/40 transition hover:bg-rose-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900"
          >
            Sign in
          </button>
        </form>
        {error ? (
          <p className="mt-4 rounded-lg bg-red-950/50 px-3 py-2 text-center text-sm text-red-300 ring-1 ring-red-500/30">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default AdminLogin;
